/**
 * Created by fers on 29.07.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import config from '../../common/config';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import EntityDefIcon from './EntityDefIcon.react';

import './ChannelIcon.scss';
import { ChannelDef } from '../../common/types/types';

interface ChannelIconProps {
    channelDef: ChannelDef;
    className?: string;
    noDimensions?: boolean;
    size: number;
}

export default class ChannelIcon extends React.Component<ChannelIconProps> {
    static propTypes = {
		channelDef: PropTypes.object.isRequired,
		className: PropTypes.string,
		noDimensions: PropTypes.bool,
        size: PropTypes.number.isRequired,
    };

    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
		let icon = this.props.channelDef.icon;

        if (!icon) {
            return (<div></div>);
        } else if (icon.startsWith("fa-")) {
            return (
                <div style={{color: 'grey', 'fontSize': '1.2em', 'textAlign': 'center'}}>
                    <EntityDefIcon icon={icon} />
                </div>
            );
        } else {
            return (<img
                         alt={this.props.channelDef.name}
                         className={icon + " " + (this.props.noDimensions ? null : "dativery-icon-" + this.props.size) + " " + (this.props.className || "")}
                         height={this.props.noDimensions ? null : this.props.size}
                         src={config.PUBLIC_CDN + "/logos/channels/resized/" + icon + "-" + (this.props.size * 2) + ".png"}
                         title={this.props.channelDef.name}
                         width={this.props.noDimensions ? null : this.props.size}
            />);
        }
    }
}
